import { SignOutButton } from "@clerk/react";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NoAccess({ email, reason }) {
  return (
    <div className="flex min-h-screen items-center justify-center px-4" data-testid="no-access-page">
      <div className="panel max-w-md space-y-4 p-8 text-center">
        <Lock className="mx-auto h-10 w-10 text-orange-500" />
        <h1 className="text-2xl font-bold tracking-tight">Kein Zugang</h1>
        <p className="text-sm text-slate-500" data-testid="no-access-message">
          {reason === "error"
            ? "Ihr Konto konnte nicht geladen werden. Bitte später erneut versuchen."
            : `Das Konto ${email || ""} ist nicht freigeschaltet. Bitte wenden Sie sich an den Administrator.`}
        </p>
        <SignOutButton>
          <Button variant="secondary" data-testid="no-access-signout-btn">Abmelden</Button>
        </SignOutButton>
      </div>
    </div>
  );
}
